<template>
    <div class="h-full cursor-pointer">
        <vx-card class="overflow-hidden relative h-full h_card" v-on="$listeners">
            <div slot="no-body" class="h-full">
                <div class="p-4">
                 
                    <div class="center">
                        <div class="flex justify-center items-center">
                            <vs-avatar class="border-2 border-solid border-white m-0" v-if="history.student.avatar" :src="history.student.avatar" size="42px" />
                            <vs-avatar class="border-2 border-solid border-white m-0" v-else :text="avatarText(history.student)" size="42px" />

                            <span class="text-lg font-semibold block text-center ml-2" style="color:rgba(var(--vs-primary), 1)">
                                {{fullName(history.student)}}
                            </span>

                        </div>
                       
                        <div class="flex justify-center mt-2">
                        
                            <div class="w-5/12 flex justify-center items-center" >
                                <vs-avatar class="border-2 border-solid border-white m-0" v-if="history.old_advisor.avatar" :src="history.old_advisor.avatar" size="42px" />
                                <vs-avatar class="border-2 border-solid border-white m-0" v-else :text="avatarText(history.old_advisor)" size="42px" />

                                <span class='ml-2'>{{ShotName(history.old_advisor)}}</span>
                            </div>
                            <div class="w-2/12 flex justify-center">
                                <vs-button radius color="warning" type="filled" icon-pack="feather" icon="icon-arrow-right"></vs-button>
                            </div>
                            <div class="w-5/12 flex justify-center items-center">
                                <vs-avatar class="border-2 border-solid border-white m-0" v-if="history.new_advisor.avatar" :src="history.new_advisor.avatar" size="42px" />
                                <vs-avatar class="border-2 border-solid border-white m-0" v-else :text="avatarText(history.new_advisor)" size="42px" />

                               <span class='ml-2'> {{ShotName(history.new_advisor)}}</span>
                            </div>
                        </div>

                        <vs-divider/>
                        <vs-col class="w-full">
                            <small class='font-medium'>{{$t('cause')}}: </small>
                            <small>{{history.cause}}</small>
                        </vs-col>

                        <vs-col class="w-full" v-if="history.comment">
                            <small class='font-medium'>{{$t('answer')}}: </small>
                            <small>{{history.comment}}</small>
                        </vs-col>

                        <vs-col class="w-full">
                            <small class='font-medium'>{{$t('status')}}: {{history.status.name}}</small>
                            <vs-progress :height="8" :percent="getOrderStatusColor(history.status.alias,'progress')" :color="getOrderStatusColor(history.status.alias)"></vs-progress>
                        </vs-col>
                    </div>
                </div>
              
              
            </div>
        </vx-card>
    </div>
</template>

<script>
import userSetting from '@/localNodeModules/setting/user.js'

export default {
    name: "ItemGridView",
    props: {
        history: {
            type: Object,
            required: true,
        }
    },
    mixins:[userSetting],
    data() {
        return {
            wMobile:false,
        }
    },
    created() {
        window.addEventListener("resize", this.myEventHandler);
    },

    methods: {
        myEventHandler(){
            this.wMobile =  window.innerWidth < 800;
        },

        getOrderStatusColor (status,type) {
            var response = ''
            switch(status) {
                case 'await':
                   response = ['warning',30];break;
                case 'processing':
                   response = ['primary',60];break;
                case 'accepted':    
                   response = ['success',100];break;
                case 'declined':    
                   response = ['danger',100];break;
            }

            if(type == 'progress'){
                return response[1]
            }
            return response[0]
        },
        avatarText(user) {
            let name = `${ user.lastName } ${ user.firstName }`

            if(name) {
                // Возвращяем инициалы пользователя
                let title,
                    text = name
                const textAr = text.split(' ')
                if (textAr.length) {
                    const newTitle = []
                    textAr.forEach(item => {
                        newTitle.push(item.substr(0, 1).toUpperCase())
                    })
                    title = newTitle.join('')
                } else title = text.substr(0, 1)
                return title
            }
        }
    },
}
</script>

<style lang="scss">

    .h_card{
        .vx-card__collapsible-content{
            height: 100%;
            padding-bottom: 39px;
        }
    }
</style>
